<div class="row" *ngIf="loading">
  <div class="loader">Loading...</div>
</div>
<div class="row" *ngIf="loaded">
  <div class="col-12 mr-auto">
    <table class="table table-striped table-bordered mt-3 text-center" style="width:100%" >
      <thead>
        <th>ID</th>
        <th>Source</th>
        <th>ShortCode</th>
        <th>Keyword</th>
        <th>Operator</th>
      </thead>
      <tbody>
        <td>{{keyword.id}}</td>
        <td>{{keyword.sourceView}}</td>
        <td>{{keyword.shortCode}}</td>
        <td>{{keyword.keyword}}</td>
        <td>{{keyword.operator}}</td>
      </tbody>
    </table>
  </div>
  <div class="col-8"><small class="text-center align-self-center">
    <i class="text-danger">* indicates mandatory field</i> &nbsp;
    <i class="fas fa-question-circle" placement="top"></i> &nbsp;
    <a target="_blank" [routerLink]="['/dashboard/support/msg-template']">View template field description</a>
  </small>

  </div>
  <div class="col-4 text-right align-self-center">
    <button class="btn btn-default mr-2  btn-sm" (click)="back()">Back</button>
    <button class="btn btn-primary  btn-sm" (click)="save()">Save</button>
  </div>
  <div class="col-12 mr-auto">
    <dl class="row">
      <dt class="col-2 text-right align-self-center"><span class="text-danger">* </span> Language :</dt>
      <dd class="col-10">
          <input type="text" [(ngModel)]="msgData.lang" class="form-control" />
      </dd>
      <dt class="col-2 text-right align-self-center">Sub Success: </dt>
      <dd class="col-10">
        <input type="text" [(ngModel)]="msgData.subscribeSuccessMsg" class="form-control" />
      </dd>
      <dt class="col-2 text-right align-self-center">Sub Already: </dt>
      <dd class="col-10">
        <input type="text" [(ngModel)]="msgData.subscribeAlreadyMsg" class="form-control" />
      </dd>
      <dt class="col-2 text-right align-self-center">Sub Failed: </dt>
      <dd class="col-10">
        <input type="text" [(ngModel)]="msgData.subscribeFailedMsg" class="form-control" />
      </dd>
      <dt class="col-2 text-right align-self-center">Sub Success With Charge: </dt>
      <dd class="col-10">
        <input type="text" [(ngModel)]="msgData.subscribeChargeSuccessMsg" class="form-control" />
      </dd>
      <dt class="col-2 text-right align-self-center">Sub Success URL With Charge: </dt>
      <dd class="col-10">
        <input type="text" [(ngModel)]="msgData.subscribeChargeSuccessUrl" class="form-control" />
      </dd>
      <dt class="col-2 text-right align-self-center">Sub Failed With Low Balance: </dt>
      <dd class="col-10">
        <input type="text" [(ngModel)]="msgData.subscribeLowBalanceMsg" class="form-control" />
      </dd>
      <dt class="col-2 text-right align-self-center">Renewal Reminder: </dt>
      <dd class="col-10">
        <input type="text" [(ngModel)]="msgData.renewalReminderMsg" class="form-control" />
      </dd>
      <dt class="col-2 text-right align-self-center">Renewal Success: </dt>
      <dd class="col-10">
        <input type="text" [(ngModel)]="msgData.renewalSuccessMsg" class="form-control" />
      </dd>
      <dt class="col-2 text-right align-self-center">Renewal Success URL: </dt>
      <dd class="col-10">
        <input type="text" [(ngModel)]="msgData.renewalSuccessUrl" class="form-control" />
      </dd>
      <dt class="col-2 text-right align-self-center">Unsub Success: </dt>
      <dd class="col-10">
        <input type="text" [(ngModel)]="msgData.unsubscribeSuccessMsg" class="form-control" />
      </dd>
      <dt class="col-2 text-right align-self-center">Unsub Already: </dt>
      <dd class="col-10">
        <input type="text" [(ngModel)]="msgData.unsubscribeAlreadyMsg" class="form-control" />
      </dd>
      <dt class="col-2 text-right align-self-center">MT Content: </dt>
      <dd class="col-10">
        <input type="text" [(ngModel)]="msgData.mtContent" class="form-control" />
      </dd>
      <dt class="col-2 text-right align-self-center">MT Content URL: </dt>
      <dd class="col-10">
        <input type="text" [(ngModel)]="msgData.mtContentUrl" class="form-control" />
      </dd>
    </dl>
  </div>
</div>

